import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'
import { useQueryClient } from '@tanstack/react-query'

const useDeletePlatformAppSectionMutation = createMutationHook(
  PlatformAppsApiClient.deletePlatformAppClientSection,
  {
    mutationKey: ['deletePlatformAppSection'],
  },
)

export const useDeletePlatformAppSection = () => {
  const queryClient = useQueryClient()
  const { deletePlatformAppSectionMutation } = useDeletePlatformAppSectionMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platformAppClient'] })
      queryClient.invalidateQueries({ queryKey: ['platformAppClients'] })
    },
  })

  return {
    deletePlatformAppSection: deletePlatformAppSectionMutation.mutate,
    isLoading: deletePlatformAppSectionMutation.isLoading,
  }
}
